import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { Investment } from '../../../types/investment/Investment'
import { updateInvestment } from '../service/investmentService'
import { useInvestmentOptions } from './useInvestment'
import loanQueryKeys from '../../loan/queries/loanQueryKeys'
import { showSuccessMessage } from '../../../utils/message'
import { investmentQueryKeys } from '../queries/investmentQueryKeys'

export const useUpdateInvestment = (isExisting: boolean) => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const queryClient = useQueryClient()
  const options = useInvestmentOptions(isExisting)

  return useMutation({
    mutationFn: (investment: Investment) => updateInvestment(companyId, investment),
    mutationKey: ['budget', 'investment', 'update'],
    onSuccess: () => {
      showSuccessMessage()
      queryClient.invalidateQueries({
        queryKey: loanQueryKeys.all
      })
      queryClient.invalidateQueries({ queryKey: options.queryKey })
      // Invalidate the specific investment detail query (for modal re-open)
      queryClient.invalidateQueries({
        queryKey: investmentQueryKeys.all
      })
    }
  })
}
